import React from "react";

const Avatar = ({ width }) =>
	<img
		style={{width: `${width}px`}}
		src={require("../../../assets/avatar-city-choice-buildings-screen.png")} />

export default Avatar;



// WEBPACK FOOTER //
// ./src/js/common/components/Avatar.js